import RestResource from '../rest.service';
import Service from '../api.service';

export default class OrdersStatisticsService extends RestResource {
  totalsByVariety(params) {
    return Service.get(`${this.resource}/varieties`, { params: params }).catch(this.handleErrors);
  }

  sellsByDistributors(campaign) {
    //TODO podriamos hacer un filtro por campaña filter[campaign]=campaign
    return Service.get(`${this.resource}/distributor/${campaign}`).catch(this.handleErrors);
  }

  totalsByCrops(params) {
    return Service.get(`${this.resource}/crops`, { params: params }).catch(this.handleErrors);
  }

  sellsBySellers(params) {
    return Service.get(`${this.resource}/sellers`, { params: params }).catch(this.handleErrors);
  }
  sellsByDistributorsPdf(campaign, filename) {
    return Service.get(`${this.resource}/distributor/${campaign}/pdf`, { responseType: 'arraybuffer' })
      .then((res) => this.downloadPDF(res, filename))
      .catch(this.handleErrors);
  }
  sellsBySellersPDF(params, filename) {
    return Service.get(`${this.resource}/sellers/pdf`, { params: params, responseType: 'arraybuffer' })
      .then((res) => this.downloadPDF(res, filename))
      .catch(this.handleErrors);
  }
  sellsByVarietiesPDF(params, filename) {
    return Service.get(`${this.resource}/varieties/pdf`, { params: params, responseType: 'arraybuffer' })
      .then((res) => this.downloadPDF(res, filename))
      .catch(this.handleErrors);
  }
  sellsByCropsPDF(params, filename) {
    return Service.get(`${this.resource}/crops/pdf`, { params: params, responseType: 'arraybuffer' })
      .then((res) => this.downloadPDF(res, filename))
      .catch(this.handleErrors);
  }

  constructor() {
    super('orders/statistics');
  }
}
